import { Dialog, DialogContent } from '@mui/material'
import get from 'lodash/get'
import { FC, useState } from 'react'

import { PopoverButton } from '../../../components'
import { stopPropagation } from '../../../lib'
import { getCoinPlusPlanDetails } from '../../../plans'
import { useUpgrade } from '../../../store'
import { purchaseTracker } from '../../../utils'
import { CheckoutApolloProvider } from '../../contexts'
import { Checkout } from '../Checkout'
import Popover from './BuyNow'
import useHandleSuccess from './useHandleSuccess'

const PurchasePlus: FC<React.PropsWithChildren<{ popover?: boolean }>> = ({ popover, ...props }) => {
  const [open, setOpen] = useState(false)
  const [, { confirmPlusFHR }] = useUpgrade()
  const plusPlan = getCoinPlusPlanDetails()
  const plusTracker = purchaseTracker(plusPlan)
  const handleSuccess = useHandleSuccess(plusPlan, plusTracker)
  const { label, buttonText } = plusPlan

  const buyPlus = () => {
    setOpen(true)
  }

  return (
    <>
      <PopoverButton
        variant="outlined"
        sx={{ mx: 1 }}
        onClick={popover ? undefined : stopPropagation(buyPlus)}
        renderPopover={() => <Popover onConfirmFHR={confirmPlusFHR} onBuyNow={buyPlus} title={label} />}
        onRenderPopover={plusTracker.view}
      >
        {props.children || buttonText}
      </PopoverButton>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogContent>
          <CheckoutApolloProvider>
            <Checkout
              onSuccess={handleSuccess}
              onCancel={() => setOpen(false)}
              onDisplay={() => plusTracker.click()}
              onCustomerInfoComplete={() => plusTracker.step(1)}
              onShippingInfoComplete={() => plusTracker.step(2)}
              onPaymentInfoComplete={() => plusTracker.step(3)}
            />
          </CheckoutApolloProvider>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default PurchasePlus
